import { Serializable } from 'src/app/common/types'
import { FlytrexMapDrawable } from 'src/app/controls'
import { uniqueId } from 'src/app/common'
import { FlightNetwork } from './flight_network.model'
import { FlightNetworkEdgeState } from 'src/app/@store'

export class NetworkEdge extends Serializable<NetworkEdge> implements FlytrexMapDrawable, FlightNetworkEdgeState {
  id: number = null
  from_vertex_id: number = null
  to_vertex_id: number = null
  network_id: number = null

  idForMap: string
  fromNodeIdForMap: string
  toNodeIdForMap: string

  constructor(details: any) {
    super()
    this.checkAndDeserialize(details)
  }

  deserialize(details: FlightNetworkEdgeState): void {
    this.id = details['id']
    this.from_vertex_id = details['from_vertex_id']
    this.network_id = details['network_id']
    this.to_vertex_id = details['to_vertex_id']

    this.idForMap = details['idForMap'] || this.getIdForMap()
    this.fromNodeIdForMap = details['fromNodeIdForMap']
    this.toNodeIdForMap = details['toNodeIdForMap']
  }

  getIdForMap(): string {
    if (!this.idForMap) {
      this.idForMap = `edge${uniqueId()}`
    }
    return this.idForMap
  }

  addNodeIdsForMap(network: FlightNetwork) {
    const fromNode = network.idMap.get(this.from_vertex_id)
    const toNode = network.idMap.get(this.to_vertex_id)

    if (!fromNode || !toNode) {
      console.log(`Can't set map nodes ids for edge`)
      return
    }

    this.fromNodeIdForMap = fromNode.idForMap
    this.toNodeIdForMap = toNode.idForMap
  }

  toJSON(): FlightNetworkEdgeState {
    return {
      id: this.id,
      from_vertex_id: this.from_vertex_id,
      network_id: this.network_id,
      to_vertex_id: this.to_vertex_id,
    }
  }
}
